import script from "./TicketChoiceGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./TicketChoiceGuide.vue?vue&type=script&lang=ts&setup=true"

import "./TicketChoiceGuide.vue?vue&type=style&index=0&id=07f0b814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f0b814"]])

export default __exports__